import * as THREE from 'three';
import { insoleV1Config } from "data/highLevelJointsInsole";
import { sandalV1Config } from "data/highLevelJointsSandal";
import { HighHeelV1Config } from "data/highLevelJointsHighHeel";
import { DesignCategory } from 'models/InsoleDesign';

export interface HighLevelJoint {
  vertices: {
    ids: number[];
    weight: number;
  }[];
  centerId: number;
  name: string;
  min: number;
  max: number;
  value: number;
  center: THREE.Vector3;
  cval: number;
  bval: number;
}

export interface MeshJoints {
  profile: HighLevelJoint[];

  surface: {
    heelDepth: HighLevelJoint;
    heelHeight: HighLevelJoint;
    heelLateralWedge: HighLevelJoint;
    heelMedialWedge: HighLevelJoint;

    archLateralHeight: HighLevelJoint;
    archCenterHeight: HighLevelJoint;
    archMedialHeight: HighLevelJoint;
    archSagitalPosition: HighLevelJoint;

    thickness: HighLevelJoint;

    forefootLateralWedge: HighLevelJoint;
    forefootMedialWedge: HighLevelJoint;

    bandHeight: HighLevelJoint | null;
    outsoleThickness: HighLevelJoint | null;
  };
}

export interface MeshConfig {
  joints: MeshJoints;

  roofVertices: HighLevelJoint;
  roofJoints: HighLevelJoint;

  pressureAlignmentDefault: [number, number];
  archLineIndices: number[];
  inStepAreaIndices: number[];

  heelFillIndices: number[];
  archFillIndeices: number[];

  forefootIndex: number;
  archStartIndex: number;
  archEditorIndex: number;
  heelCenterIndex: number;
  bandStartIndex: number;
}

export enum MeshCategory {
  InsoleV1 = "InsoleV1",
  SandalV1 = "SandalV1",
  HighHeelV1 = "HighHeelV1",
}

// export const meshConfigs: Record<MeshCategory, MeshConfig> = {
//   [MeshCategory.InsoleV1]: insoleV1Config,
//   [MeshCategory.SandalV1]: sandalV1Config,
//   [MeshCategory.HighHeelV1]: insoleV1Config,
// };

export const meshConfigs: Record<DesignCategory, MeshConfig> = {
  [DesignCategory.Insole]: insoleV1Config,
  [DesignCategory.Sandal]: sandalV1Config,
  [DesignCategory.HighHeel]: HighHeelV1Config,
};